import React, { useEffect } from 'react';

export default function GalleryLightbox({ images, currentIndex, onClose, onPrev, onNext }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };
    window.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [onClose, onPrev, onNext]);

  if (currentIndex === null || !images[currentIndex]) return null;

  const current = images[currentIndex];

  return (
    <div className="fixed inset-0 z-50 bg-black/90 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in duration-200">
      
      {/* Close button */}
      <button
        onClick={onClose}
        className="absolute top-6 right-6 text-white text-2xl hover:text-[#2E3191] p-2 z-50 cursor-pointer"
        aria-label="Close modal"
      >
        <i className="fa-solid fa-xmark" />
      </button>

      {/* Prev button */}
      {images.length > 1 && (
        <button
          onClick={onPrev}
          className="absolute left-4 sm:left-8 text-white text-3xl hover:text-[#2E3191] p-3 rounded-full bg-white/10 hover:bg-white/20 transition-all z-50 cursor-pointer"
          aria-label="Previous image"
        >
          <i className="fa-solid fa-chevron-left" />
        </button>
      )}

      {/* Image container */}
      <div className="max-w-4xl max-h-[85vh] flex flex-col items-center">
        <img
          src={current.image}
          alt={current.title}
          className="max-h-[75vh] w-auto max-w-full object-contain rounded-lg shadow-2xl border border-white/10"
        />
        {current.title && (
          <p className="mt-4 text-center font-serif-display text-xl text-white font-medium">
            {current.title}
          </p>
        )}
        <span className="text-xs text-white/60 mt-1">
          {currentIndex + 1} / {images.length}
        </span>
      </div>

      {/* Next button */}
      {images.length > 1 && (
        <button
          onClick={onNext}
          className="absolute right-4 sm:right-8 text-white text-3xl hover:text-[#2E3191] p-3 rounded-full bg-white/10 hover:bg-white/20 transition-all z-50 cursor-pointer"
          aria-label="Next image"
        >
          <i className="fa-solid fa-chevron-right" />
        </button>
      )}
    </div>
  );
}
